<template>
	<div>
		<select multiple v-model="selectedTeams">
			<option
				v-for="(team, index) in orderedTeams"
				:value="team.id"
				:key="team.id">
				{{team.name}}
			</option>
		</select>
		<input type="" name="" disabled :value="selectedTeams">
	</div>
</template>

<script>
	export default {
		name: 'team',
		data () {
			return {
				teams: [],
				selectedTeams: []
			}
		},
		methods: {
			getData: function(endpoint, callback) {
				let self = this;
				var xhr = new XMLHttpRequest();
				xhr.open('GET', endpoint, true);
				xhr.send(null);

				xhr.onreadystatechange = function () {
					var
					DONE = 4,
					OK = 200;
						
					if (xhr.readyState === DONE) {
						if (xhr.status === OK) {
							let jsonResponse = JSON.parse(xhr.responseText)
							callback(jsonResponse);
						} else {
							console.log('Error: ' + xhr.status)
						}
					}
				}
			},
			compare: function(a,b) {
				if (a.name < b.name) {
					return - 1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			}
		},
		mounted: function () {
			let self = this;
			this.getData('https://api.ffa.football/sync/teams', function(callback){
				self.teams = callback;
				//self.selectedTeams.push(callback[0].id);
			});
		},
		computed: {
			orderedTeams: function() {
				return this.teams.sort(this.compare);
			}
		},
		watch: {
			selectedTeams: function() {
				this.$emit('teamUpdated', this.selectedTeams);
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Team.vue?fbd100fe